<template>
  <v-layout>
    <v-flex class="align-self-center text-truncate map-report-name" grow>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-layout v-on="on">
            <v-flex v-if="!isComplete" class="name-style">{{ name }}</v-flex>
            <a v-if="isComplete" :href="mapReportUrl">
              <div class="name-style">{{ name }}</div>
            </a>
          </v-layout>
        </template>
        <span>{{ name }}</span>
      </v-tooltip>
    </v-flex>
    <v-flex class="buttonEdit" shrink>
      <v-edit-dialog
        @save="onClickSave"
        large
        save-text="変更"
        cancel-text="キャンセル"
      >
        <v-flex>
          <v-icon @click="onClickEdit" small>edit</v-icon>
        </v-flex>
        <template v-slot:input>
          <v-text-field
            @update:error="updatedValidationFlag($event)"
            v-model="inputName"
            :rules="rules"
            class="name-text-field"
            label="レポート名"
            autofocus
          />
        </template>
      </v-edit-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { MapReportListRepository, MapReportStatuses } from '@/models/MapReport'

const validationMessage = 'レポート名は1~50文字以内にしてください。'

export default {
  name: 'MapReportRequestListName',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputName: this.name,
      isValidError: false,
    }
  },
  computed: {
    isComplete() {
      return this.status === MapReportStatuses.Completed
    },
    mapReportUrl() {
      return `map_reports/${this.id}`
    },
    rules() {
      return [v => (v.length > 0 && v.length <= 50) || validationMessage]
    },
  },
  methods: {
    updatedValidationFlag(isValidError) {
      this.isValidError = isValidError
    },
    onClickEdit() {
      this.inputName = this.name
    },
    async onClickSave() {
      if (this.isValidError) {
        const result = await this.$confirm(validationMessage, {
          okText: '閉じる',
          onlyOk: true,
        })
        this.inputName = ''
        if (result) return
      }
      try {
        await MapReportListRepository.updateName(this.id, this.inputName)
        this.$emit('onClickSave', this.inputName)
      } catch (e) {
        console.error(e)
        throw new Error('レポート名の更新に失敗しました。')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.name-style {
  flex: 1;
  max-width: 300px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.map-report-name {
  max-width: 305px;
}
.name-text-field {
  margin-top: 20px;
  width: 400px;
}
.buttonEdit {
  ::v-deep a:hover {
    text-decoration: none;
  }
}
</style>
